import * as React from 'react';

function SvgArrowLeftOutline(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <path d="M30 15H5.42l8.3-8.28L12.3 5.3 1.58 16 12.3 26.72l1.42-1.42L5.41 17H30v-2z" />
    </svg>
  );
}

export default SvgArrowLeftOutline;
